// src/config.js

const BACKEND_URL = "https://backend.armureppf.com";

export default BACKEND_URL;
